export const panNoRegex = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/;
export const aadhaarNoRegex = /^[2-9]{1}[0-9]{3}\s?[0-9]{4}\s?[0-9]{4}$/;
